export default {
    router: {
        index: {
            home: 'home',
            login: 'Log In',
            error401: 'error 401',
            error404: 'error 404',
            error500: 'error 500',
        },
        router: {
            beforeClose: {
                sureClose: 'Sure to close this page',
            },
        },
    },
    views: {
        public: {
            operatSuccess: 'Operation Succeed',
            operatError: 'Operation Failed',
            pass: 'Pass',
            refuse: 'Refuse',
            passed: 'Passed',
            refused: 'Refused',
            close: 'Close',
            submit: 'Submit',
            yes: 'Yes',
            no: 'No',
            sure: 'confirm',
            cancel: 'cancel',
            prompt: 'Prompt',
            operation: 'Operation',
            delete: 'Delete',
            edit: 'Edit',
            query: 'Search',
            update: 'Modify',
            turkish: 'Turkish',
            arabic: 'Arabic',
            indonesian: 'Indonesian',
            en: 'English',
            all: 'All',
            noPermission: 'No permission',
            pleaseChoose: 'please choose',

            none: 'Empty',
            sex: 'Porn / Sex',
            curse: 'Insult',
            religion: 'Disrespect for Religion',
            terroristActivities: 'Terrorist Activities',
            violationOfLaw: 'Violation of Law',
            propaganda: 'Promote Other App',
            resetHeadImg: 'Reset Avatar',
            search: 'Search',

            confirmOpear: 'Confirm the operation',
            noneData: 'No data',
            operatSuccessUpdate: 'Operation successful, updating status',
            pleaseChooseTarget: 'Please select the target',
            chooseAll: 'select all',
            permanentBan: 'Permanent ban',
        },
        page401: {
            content: 'You do not have permission to browse this page.',
        },
        page404: {
            content: 'Oh ~~ Your Page Seems To Fly Away ~',
        },
        page500: {
            content: 'Oh ~~ Ghost Knows What The Server Has Experienced ~',
        },
        backBtnGroup: {
            backHome: 'Back To Home Page',
            backLast: 'Go Back To The Last Page',
        },
        login: {
            title: 'hilo management system',
        },
    },
    components: {
        banModal: {
            chooseTime: 'Choose a duration',
            chooseReason: 'Choose a reason:',
            content: 'Report Content:',
            enterContent: 'You can enter the report content',
            enterUrl: 'Image or Video Link:',
            imgVideoUrl: 'Image or Video Link:',
            banUser: 'Confirm Banned Users?',
            ban24: 'Ban 24 hours',
            ban72: 'Ban 72 hours',
            ban30D: 'Ban 30 days',
            permanentBan: 'Permanent ban',
        },
        loginForm: {
            enterUserName: 'Please Enter User Name',
            enterPassword: 'Please Enter The Password',
            login: 'Log In',
            accountNotNone: 'Account Cannot Be Empty',
            passwordNotNone: 'Password Can Not Be Empty',
        },
        fullScreen: {
            exitScreen: 'Exit full screen mode',
            fullScreen: 'Full Screen',
        },
        headerBar: {
            title: 'hilo management system',
        },
        tagsNav: {
            closeAll: 'Close All',
            closeOther: 'Close Other',
        },
        user: {
            signOut: 'Sign Out',
        },
        publicCheckPassword: {
            checkPassword: 'Enter and confirm the operation password',
            checkSuccess: 'Verify Successfully',
        },
        tableBox: {
            noneData: 'No Data',
        },
        tableSearch: {
            search: 'Query Conditions',
        },
    },
    js: {
        request: {
            systemError: 'Server System Internal Error',
            unLogin: 'Did not logged in',
            timeOut: 'Request Timed Out',
            linkError: 'Network connection failed',
            unknownMis: 'Unknown Error',

            serverError: 'Internal server error',
            missParams: 'Missing parameters',
            unToken: 'Token not submitted',
            tokenExpired: 'Token expired',
            addError: 'Add failed, administrator already exists',
            noFoundAdmin: 'This manager cannot be found',
            loginError: 'Login failed, wrong account or password',
        },
    },
}


// WEBPACK FOOTER //
// ./src/language/en.js